import { useApolloClient } from '@apollo/client';
import { SkillsAllocationEditView } from 'pages/Settings/pages/LocationSettings/SkillsAllocation/SkillsAllocationSettingsPage.edit';
import { SkillsAllocationReadView } from 'pages/Settings/pages/LocationSettings/SkillsAllocation/SkillsAllocationSettingsPage.read';
import { useLocationSkillsStore } from 'pages/Settings/pages/LocationSettings/SkillsAllocation/store/locationSkills.store';
import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import isUserSecondarySelector from 'store/selectors/userSelectors/isUserSecondarySelector';

export const SkillsAllocationSettingsPage: FC = () => {
  const apolloClient = useApolloClient();
  const match = useRouteMatch<{ locationId: string }>();
  const isUserSecondary = useSelector(isUserSecondarySelector);
  const fetchSkills = useLocationSkillsStore((state) => state.fetchSkills);

  const communityId = Number(match.params.locationId);

  useEffect(() => {
    if (communityId > 0) return fetchSkills(apolloClient, communityId);
    return undefined;
  }, [apolloClient, fetchSkills, communityId]);

  if (isUserSecondary) return <SkillsAllocationReadView />;

  return (
    <Switch>
      <Route exact path={match.path} component={SkillsAllocationReadView} />
      <Route path={`${match.path}/edit`} component={SkillsAllocationEditView} />
    </Switch>
  );
};
